module.exports = __webpack_public_path__ + "assets/icon-face-happy-component.d97e5066.svg";